import { useMutation, useQueryClient } from "@tanstack/react-query";

import { mutateData } from "@/core/api/api-methods";
import {
  apiErrorHandler,
  getBackendErrorMessage,
} from "@/core/api/api-error-handler";
import {
  invalidateAfterMutation,
  notificationProviderCacheKeys,
} from "@/core/api/invalidate-after-mutation";
import { logger } from "@/core/utils/func/logger";
import { notificationEndpoints } from "@/features/notification/api/endpoints";

/**
 * Supprime une ligne de routage (`DELETE /NotificationProviders/{id}`, guide
 * v2.3 §6.7). Le repli s'arrête à la dernière ligne active d'un canal.
 */
export const useDeleteNotificationProvider = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationKey: ["notification", "providers", "delete"],
    mutationFn: (notificationProviderId: string) =>
      mutateData({
        url: notificationEndpoints.providers.remove(notificationProviderId),
        method: "DELETE",
      }) as Promise<void>,
    onSuccess: () =>
      invalidateAfterMutation(queryClient, notificationProviderCacheKeys()),
    onError: (error) => {
      const message = getBackendErrorMessage(error) ?? apiErrorHandler(error);
      logger.error(
        `useDeleteNotificationProvider failed: ${message}`,
        error instanceof Error ? error : undefined,
        { prefix: "notification" }
      );
    },
  });
};
